import React from "react";
import { memo } from "react";
import styles from "./DimensionsPanel.module.scss";
import Stack from "@mui/material/Stack";
import { Tab, Tabs } from "../../../shared/ui/Tabs";
import RoomParamsTab from "./components/RoomParamsTab";
import { SectionsParamsTab } from "./components/SectionsParamsTab/SectionsParamsTab";
import DecorsParamsTab from "./components/DecorsParamsTab";
import { useStoreSystem } from "../../../../store";
import shallow from "zustand/shallow";

interface DimensionsPanelProps {
    proMode: boolean;
}
export const DimensionsPanel = memo(({ proMode }: DimensionsPanelProps) => {
    const [value, setValue] = React.useState("1");

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };
    const { currentSide } = useStoreSystem(
        (state) => ({
            currentSide: state.currentSide,
        }),
        shallow
    );

    return (
        <Stack spacing={1.25} className={styles.root}>
            <Tabs value={value} onChange={handleChange}>
                <Tab label="параметры комнаты" value="1" />
                <Tab label="параметры стеллажа" value="2" />
                <Tab label="Наполнение комнаты" value="3" />
            </Tabs>
            {value === "1" && <RoomParamsTab proMode={proMode} />}
            {value === "2" && currentSide !== "top" && <SectionsParamsTab />}
            {value === "3" && <DecorsParamsTab />}
        </Stack>
    );
});
